module.exports = __webpack_public_path__ + "img/receipt.183cd4b9.png";